'use client'

import Image from 'next/image'
import { useSyncExternalStore } from 'react'
import { SANTA_CALL_LOOP, SANTA_IDLE_POSTER } from '@/lib/santa-chat/gestures.manifest'

const noSubscription = () => () => {}

/**
 * La media del hero: el mismo Papá Noel del chat, en su bucle de «llámame»
 * (mudo). El póster optimizado es la imagen de carga (LCP); el vídeo solo
 * existe tras hidratar, para no competir con ella, y sin `poster` propio (el
 * de debajo ya cubre hasta el primer fotograma). Con movimiento reducido el
 * navegador ni lo descarga.
 */
export function FreeSantaHeroMedia({ alt }: { alt: string }) {
  const hydrated = useSyncExternalStore(noSubscription, () => true, () => false)
  return (
    <div className="relative mx-auto w-full max-w-[420px]">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-amber-400/20 to-emerald-400/20 blur-2xl" />
      <div className="relative aspect-[4/5] overflow-hidden rounded-3xl border-4 border-white/20 shadow-2xl">
        <Image src={SANTA_IDLE_POSTER} alt={alt} fill loading="eager" fetchPriority="high" sizes="(min-width: 768px) 420px, 100vw" className="object-cover object-top" />
        {hydrated && (
          <video autoPlay muted loop playsInline aria-hidden className="absolute inset-0 h-full w-full object-cover object-top motion-reduce:hidden">
            <source src={SANTA_CALL_LOOP} type="video/mp4" media="(prefers-reduced-motion: no-preference)" />
          </video>
        )}
      </div>
    </div>
  )
}
